import React from 'react';
const testimonials = [{
  name: 'Mark W.',
  role: 'Youth Coach, London',
  stars: 5,
  text: 'Since I started using the Ready-Pack, I save at least 3 hours a week. My players notice the difference — training is more structured and varied than ever before.',
  timeAgo: '2 weeks ago'
}, {
  name: 'Sarah K.',
  role: 'U14 Coach, Manchester',
  stars: 5,
  text: 'Finally a system that actually works! The drills are clearly explained, and I can show the graphics right on the pitch. My team has made huge progress in just 4 weeks.',
  timeAgo: '5 days ago'
}, {
  name: 'Tom R.',
  role: 'Grassroots Coach, Birmingham',
  stars: 5,
  text: 'As a new coach, I was often unsure of what to run. With the Football Ready-Pack, I feel like a pro. The season planner alone is worth ten times the price.',
  timeAgo: '1 week ago'
}, {
  name: 'Julie M.',
  role: 'School Team Manager, Leeds',
  stars: 5,
  text: 'I run a football team at a primary school and had zero experience. This pack made starting so easy — the kids love the new drills!',
  timeAgo: '3 days ago'
}, {
  name: 'Steve H.',
  role: 'U16 Coach, FA Level 2',
  stars: 5,
  text: 'The tactical progression is brilliantly thought out. From basic passing to advanced pressing — everything builds logically. Highly recommended for any ambitious coach.',
  timeAgo: '10 days ago'
}, {
  name: 'Andy B.',
  role: 'Senior Team Manager, Liverpool',
  stars: 5,
  text: "I've been coaching for 15 years and thought I'd seen it all. The Ready-Pack still gave me fresh ideas. The 101 Finishing Drills are absolute gold.",
  timeAgo: '1 week ago'
}];
export function TestimonialsSection() {
  return <section className="w-full bg-bg-dark py-20 px-4 relative overflow-hidden" data-id="element-220">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(234,88,12,0.06) 0%, transparent 70%)'
    }} data-id="element-221"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-222">
        <div className="text-center mb-14" data-id="element-223">
          <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-4 tracking-tight" data-id="element-224">
            What other coaches say
          </h2>
          <p className="text-text-sec text-lg sm:text-xl max-w-2xl mx-auto" data-id="element-225">
            Over 800 verified reviews from coaches across the UK.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-226">
          {testimonials.map((t, i) => <div key={i} className="bg-bg-alt rounded-2xl border border-border-light p-6 flex flex-col gap-4 hover:border-primary/30 transition-colors group relative overflow-hidden" data-id="element-227">
              {/* Subtle hover glow */}
              <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-228"></div>

              {/* Stars */}
              <div className="flex items-center gap-1 relative z-10" data-id="element-229">
                {Array.from({
              length: t.stars
            }).map((_, s) => <span key={s} className="text-secondary text-lg" data-id="element-230">
                    ⭐
                  </span>)}
              </div>

              {/* Quote */}
              <p className="text-text-main text-[15px] leading-relaxed font-medium relative z-10 flex-1" data-id="element-231">
                "{t.text}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-3 pt-4 border-t border-border-light/50 relative z-10" data-id="element-232">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-primary/20 to-primary/5 border border-primary/30 flex items-center justify-center flex-shrink-0 shadow-inner" data-id="element-233">
                  <span className="text-sm font-bold text-primary" data-id="element-234">
                    {t.name.charAt(0)}
                  </span>
                </div>
                <div className="min-w-0" data-id="element-235">
                  <p className="text-text-main font-bold text-sm" data-id="element-236">{t.name}</p>
                  <p className="text-text-sec text-xs" data-id="element-237">{t.role}</p>
                </div>
                <div className="ml-auto flex items-center gap-1.5 flex-shrink-0" data-id="element-238">
                  <div className="w-2 h-2 bg-check-green rounded-full shadow-[0_0_6px_rgba(16,185,129,0.6)]" data-id="element-239"></div>
                  <span className="text-text-sec text-[10px] font-bold uppercase tracking-wider" data-id="element-240">
                    Verified
                  </span>
                </div>
              </div>
            </div>)}
        </div>

        {/* Summary bar */}
        <div className="mt-10 bg-bg-alt border border-border-light rounded-2xl p-5 sm:p-6 flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 text-center" data-id="element-241">
          <div className="flex items-center gap-2" data-id="element-242">
            <span className="text-secondary text-lg" data-id="element-243">⭐⭐⭐⭐⭐</span>
            <span className="text-text-main font-bold text-lg" data-id="element-244">4.9 / 5</span>
          </div>
          <div className="h-6 w-px bg-border-light hidden sm:block" data-id="element-245"></div>
          <p className="text-text-sec font-medium text-sm sm:text-base" data-id="element-246">
            Based on{' '}
            <span className="text-text-main font-bold" data-id="element-247">+800 reviews</span> from
            verified buyers
          </p>
        </div>
      </div>
    </section>;
}